
























import Vue from 'vue'
import { InhalerProduct, InhalerTypes } from '@/jsonapi/CommonTypes'
import ChartCardContainer from '@/components/layouts/ChartCardContainer.vue'
import { joinWith } from '@/utils/labels'
import { getControlledDaysChartOptions } from '@/components/patient-stats/graphs/summary-reports/chart-options/rescue-inhaler-charts/ControlledDaysChartOptions'

export default Vue.extend({
  components: {
    ChartCardContainer,
  },
  props: {
    patientId: {
      type: String,
      required: true,
    },
    patientWithStats: {
      type: Object,
      required: true,
    },
  },
  computed: {
    activeRescueInhalers(): InhalerProduct[] {
      if (!this.patientWithStats || !this.patientWithStats.activeInhalers) {
        return []
      }
      return this.patientWithStats.activeInhalers.filter(inhaler => inhaler.productType === InhalerTypes.Reliever)
    },
    activeInhalerNames(): Array<Pick<InhalerProduct, 'productName'>> {
      return this.activeRescueInhalers.map(inhaler => inhaler.productName)
    },
    inhalerUsageTitle() {
      if (!this.activeInhalerNames.length) {
        return ''
      }
      return `${joinWith(this.activeInhalerNames)} ${this.activeInhalerNames.length > 1 ? 'Usages' : 'Usage'}`
    },
    uncontrolledDays() {
      return this.patientWithStats && this.patientWithStats.uncontrolledDays
    },

    controlledDays() {
      return this.patientWithStats && this.patientWithStats.controlledDays
    },
    hasDatapoints: {
      get() {
        const returnVal = this.uncontrolledDays != null && this.controlledDays != null
        return returnVal
      },
    },
    hasBadDataPoints() {
      return this.hasDatapoints && (this.uncontrolledDays < 0 || this.controlledDays < 0)
    },
    controlledDaysChartOptions() {
      return getControlledDaysChartOptions(this.controlledDays, this.uncontrolledDays)
    },
  },
})
